import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {UzurvPipesModule} from '@uzurv/core';
import { AlertDialogComponent } from './alert-dialog.component';

@NgModule({
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, UzurvPipesModule],
    exports: [AlertDialogComponent],
    declarations: [AlertDialogComponent]
})
export class AlertDialogModule {}
